window.arFaqDetailFormatter = function(value, row) {
    let html = '';
    if (row.answer) {
        html += '<span class="fw-bold">'+__('Answer')+'</span>';
        html += '<p>'+row.answer+'</p>';
    }
    return html;
};
